import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { IPagination } from '../interface/ICommon';
import { RootState } from '../store';

export const PaginationMobile = ({ dat }: { dat: IPagination }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);

    if (!dat || dat.lastPage < 2) {
        return null;
    }
    const { changeParam } = useRouter([]);
    const selectRef = useRef<HTMLSelectElement>(null);

    const onPageSelect = () => {
        if (!selectRef.current) return;
        const val = selectRef.current.value;
        changeParam({ page: val });
    };

    const onPrev = () => {
        let val = dat.page - 1;
        if (val < 1) {
            val = 1;
        }
        changeParam({ page: val.toString() });
    };

    const onNext = () => {
        let val = dat.page + 1;
        if (val > dat.lastPage) {
            val = dat.lastPage;
        }
        changeParam({ page: val.toString() });
    };

    return (
        <div className="ui-pagination is-mobile">
            <div className="pagination-list">
                <button onClick={onPrev} className={`prev ${dat.page < 2 ? 'is-disabled' : ''}`} title="Prev">
                    <span>{l10n['price.prev']}</span>
                </button>
                <button onClick={onNext} className={`next ${dat.page >= dat.lastPage ? 'is-disabled' : ''}`} title="Next">
                    <span>{l10n['price.next']}</span>
                </button>
            </div>
            <div className="pagination-select">
                <div className="pagination-select-page">
                    <select value={dat.page} onChange={onPageSelect} ref={selectRef}>
                        {Array.from({ length: dat.lastPage }).map((_, i) => (
                            <option value={i + 1} key={i + '_page'}>
                                {i + 1}
                            </option>
                        ))}
                    </select>
                    <i></i>
                </div>
                <div
                    className="pagination-total"
                    dangerouslySetInnerHTML={{ __html: l10n['price.page'].replace('{N}', dat.lastPage.toString()) }}
                ></div>
            </div>
        </div>
    );
};
